import { Helpers } from '@customink/signalmizely-web';
import { isBrowser } from '../constants/constants';

export const signalmizelyHelpers = isBrowser ? new Helpers({ sdkKey: process.env.OPTIMIZELY_SDK_KEY }) : (null as any);
